import { featureItems } from '@/mocks/home';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              平台特色
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {featureItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl border border-background-200/60 p-6 md:p-8 text-center group hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-primary-600 text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}